import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import {
  DATE_SHORT_FORMAT, orders_list_list_all_organisations_all
} from "../../constants";
import {apiRequest} from "../../utils/request";
import ReactTable from "react-table";
import moment from "moment/moment";
import {Link} from "react-router-dom";
import {updateNonPostFilter} from "../../actions/orderActions";

class FabricationOrdersListPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      orders: null,
      columns: [],
      loaded: false,
    };

    this.loadOrders = this.loadOrders.bind(this);
    this.setColumns = this.setColumns.bind(this);
  }

  componentDidMount() {
    this.loadOrders();
  }
  
  loadOrders() {
    apiRequest(`/api/fabrications/orderviewlist`)
        .then(x => {
          this.setState({orders: x.data, loaded: true});
          this.setColumns();
        });

  }

  setColumns() {
    this.setState({
      columns: [{
        id: 'id',
        Header: 'Ref',
        accessor: d => `FM-1${String(d.id).padStart(5, '0')}`,
        maxWidth: 100,
      }, {
        id: 'createdDate',
        Header: `Created Date`,
        accessor: d => moment(d.createdDate).format(DATE_SHORT_FORMAT),
        sortMethod: (a, b) => {
          let aVal = moment(a, DATE_SHORT_FORMAT);
          let bVal = moment(b, DATE_SHORT_FORMAT);

          return aVal.isBefore(bVal) ? -1 : 1;
        },
        maxWidth: 120,
      }, {
        id: 'customerName',
        Header: 'Customer Name',
        accessor: d => d.customerName,
      }, {
        id: 'customerRef',
        Header: 'CRN',
        accessor: d => d.customerRef,
      }, {
        id: 'productShortName',
        Header: 'Product Name',
        accessor: d => d.productShortName,
      }, {
        id: 'width',
        Header: 'Width',
        accessor: d => d.width,
      }, {
        id: 'projection',
        Header: 'Projection',
        accessor: d => d.projection,
      },
        {
          id: 'actions',
          Header: '',
          accessor: c => {
            return (
                <span>
                  <Link
                      to={`/fabricationOrders/edit/${c.id}`}
                      className={'mr-3'}
                  ><i className="fa fa-edit fa-lg" /></Link>
                  <Link
                      to={`/fabricationOrders/view/${c.id}`}
                      className={'mr-3'}
                  ><i className="fa fa-file-text-o fa-lg" /></Link>
            </span>
            );
          },
          width: 125,
        }]
    });
  }
  

  render(){
    let {orders, columns, loaded} = this.state;

    return loaded ? (
        <div className={"row mt-2"}>
          <div className={'pi-col-sm-4'} style={{ padding: '15px' }}>
            <h4>View Fabrication Awning Orders</h4>
          </div>
          <div className={'pi-col-sm-8'} style={{ textAlign: 'right', padding: '15px' }}>
            {/*Don't need this Refresh button yet as there are no filters, uncomment once filters are added*/}
            {/*<button
                onClick={(e) => {
                  e.preventDefault();
                  this.loadOrders();
                }}
                className="btn pi-btn pi-uppercase"
                style={{marginRight: '5px'}}
            >
              <i className="fa fa-retweet"></i>&nbsp;Refresh Results
            </button>
            &nbsp;*/}
            <button
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push('/fabricationOrders/create');
                }}
                className="btn pi-btn-base pi-uppercase pi-letter-spacing">
              <i className="fa fa-plus"></i>&nbsp;Create New Fabrication
            </button>
          </div>
          <div className={"col-12"} style={{ paddingBottom: '15px' }}>
            <ReactTable
                filterable={false}
                data={orders}
                columns={columns}
            />
          </div>
        </div>
    ) : (
        <div className="pi-section">
          <div className="pi-row">
            <div className="pi-col-md-8">
              <h4 className="pi-has-bg pi-margin-bottom-20">
                Loading... <i className={'fa fa-spinner fa-spin'} />
              </h4>
            </div>
          </div>
        </div>
    );
  }
}

FabricationOrdersListPage.propTypes = {
  fabricationOrderId: PropTypes.number.isRequired,
};

function mapStateToProps(state, ownProps) {
  let fabricationOrderId = -1;
  if(ownProps.match.params && ownProps.match.params.fabricationOrderId){
    fabricationOrderId = parseInt(ownProps.match.params.fabricationOrderId);
  }
  
  return {
    fabricationOrderId,
    siteSettings: state.lookups.siteSettings,
    theme: state.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FabricationOrdersListPage));